import { Box, Fab } from '@mui/material'
import Divider from '@mui/material/Divider'
import { styled } from '@mui/material/styles'

const Content = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding-top: 4px;
`

const DivisorStepper = styled(Divider)`
  margin-top: 10px;
  margin-bottom: 10px;
`

const BotaoImportar = styled(Fab)`
  margin-top: 3%;
`

const Acoes = styled(Box)`
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 12px;
`

export { Content, DivisorStepper, BotaoImportar, Acoes }
